/**
 * Single site-wide parser for D1 / API timestamps (ISO-Z or sqlite `YYYY-MM-DD HH:MM:SS` as UTC).
 */

export function normalizeSiteInstant(raw: string): string {
  const text = raw.trim();
  if (!text) return text;
  if (text.includes("T")) return text;
  return `${text.replace(" ", "T")}Z`;
}

export function parseSiteInstantMs(raw: string | null | undefined): number | null {
  if (raw == null) return null;
  const text = raw.trim();
  if (!text) return null;
  const ms = Date.parse(normalizeSiteInstant(text));
  return Number.isFinite(ms) ? ms : null;
}

export function parseSiteInstant(raw: string | null | undefined): Date | null {
  const ms = parseSiteInstantMs(raw);
  return ms == null ? null : new Date(ms);
}
